export default "__VITE_ASSET__CVodd7Lt__"